export default class CurvePainter {
  constructor() {
    this.funcs = [this.ellipse,this.lemniskateG,this.limacon,this.cornoid,this.trisec,this.scarabeus,this.folium,this.talbot];
  }

  rotate(cx,cy,angle,x,y)
  {
    if(angle === 0) return [x,y];
    let s = Math.sin(angle);
    let c = Math.cos(angle);

    x -= cx;
    y -= cy;

    let xnew = x * c - y * s;
    let ynew = x * s + y * c;

    return [xnew + cx, ynew + cy];
  }

  ellipse(t,x,y,rx,ry,param) {
    let r = t+param*Math.sin(t);
    return [x+rx*Math.sin(r),y+ry*Math.cos(r)];
  }

  lemniskateG(t,x,y,rx,ry,param) {
    let r = t+param*Math.sin(t);
    let cosr = Math.cos(r);
    return [x+rx*cosr,y+ry*cosr*Math.sin(r)];
  }

  limacon(t,x,y,rx,ry,param) {
   let cost = Math.cos(t);
   return[x+rx*Math.sin(t)*(cost+param),y+ry*cost*(cost+param)];
  }

  cornoid(t,x,y,rx,ry,param) {
    let cos2t = Math.cos(2*t);
    return  [x+rx*Math.cos(t)*cos2t,y+ry*Math.sin(t)*(param+cos2t)];
  }

  trisec(t,x,y,rx,ry,param) {
    let sin2t = Math.sin(2*t);
    return[x+rx*Math.cos(t)*(1+param*sin2t),y+ry*Math.sin(t)*(1+param*sin2t)];
  }

  scarabeus(t,x,y,rx,ry,param) {
    let sint = Math.sin(t);
    let sin2t = Math.sin(2*t);
    return [x+rx*Math.cos(t)*(param*sin2t+sint),y+ry*sint*(param*sin2t+sint)];
  }

  folium(t,x,y,rx,ry,param) {
    let sint = Math.sin(t);
    let cost = Math.cos(t);
    return [x+rx*cost*cost*(sint*sint-param),y+ry*sint*cost*(sint*sint-param)];  
  }

  talbot(t,x,y,rx,ry,param) {
    let sint = Math.sin(t);
    let cost = Math.cos(t);
    return [x+rx*cost*(1+param*sint*sint),y+ry*sint*(1-param-param*cost*cost)];
  }

  drawCurve(context,shape,x,y,w,h,zoom,curve,param,rot,rx,ry) {
    console.log(x,y,w,h,zoom,curve,param,rot,rx,ry);
    let len = 2*Math.PI;
    let t=0;
    let k=0;
    let delta = 0.01;
    context.beginPath();
    while(t<len) {
      let p = this.funcs[curve](t,x,y,rx,ry,param);
      p = this.rotate(x,y,-rot-Math.PI,p[0],p[1]);
      let xc = (p[0]/(zoom/2))*w/2+w/2;
      let yc = (p[1]/(zoom/2))*h/2+h/2;
      if(k === 0) context.moveTo(xc,yc);
      else context.lineTo(xc,yc);
      k++;
      t+=delta;
    }
    context.closePath();
    context.strokeShape(shape);
  }

}
